const truncate = (str, length = 400, ending = '...') => {
  if (str && str.length > length) {
    return str.substring(0, length - ending.length) + ending;
  }
  return str;
};

export default truncate;



// WEBPACK FOOTER //
// ./src/utils/truncate.js